module.exports = __webpack_public_path__ + "img/ZG.77f0d133.png";